module.exports = __webpack_public_path__ + "img/bg-sm.d3d5a699.png";